var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C14 19 11.1743 19 10 19H9.50001L6.00001 22L6.00001 19C3.34319 19 1 16.7614 1 14C1 11.2386 3 9 6.00001 9",
    stroke: "#384A5F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8C23 4.60451 20.4135 2 17 2H12.5C9.08646 2 6.5 4.60451 6.5 8C6.5 11.3955 9.08646 14 12.5 14H14L17.4815 17.5037L17.5 14C21.0319 13.6531 23 11.1584 23 8Z",
    stroke: "#384A5F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.08ab688ebdc1ba0e664493299c2ff5ef.svg";
export { ForwardRef as ReactComponent };